import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import { getStartOfCurrentShopDay } from 'lib/selectors/getStartOfCurrentShopDay';

const getSevenDayLookbackStart = createSelector(
  [getStartOfCurrentShopDay],
  (startOfShopDay) => {
    if (!startOfShopDay) return null;
    return moment(startOfShopDay)
      .subtract(7, 'days')
      .toISOString();
  }
);

export { getSevenDayLookbackStart };
